import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterPagoPremio from 'views/cash/pagopremiovirtuales/filterPagoPremio'; // Importing filter component
import PagoPremio from 'views/cash/pagopremiovirtuales/PagoPremio'; // Importing PagoPremio component
import TablePagoPremio from 'views/cash/pagopremiovirtuales/tablePagoPremio'; // Importing table component
import DetailsPagoPremio from 'views/cash/pagopremiovirtuales/detailsPagoPremio'; // Importing details component
import RecordPagoPremio from 'views/cash/pagopremiovirtuales/recordPagoPremio'; // Importing record component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the payment prize view.
 * @extends JetView
 */
export default class pagoPremioView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Theme configuration
        const right = {
            // Right section layout
            type: 'wide',
            rows: [PlayersView, DetailsPagoPremio, RecordPagoPremio],
        };
        const toolbar = {
            // Toolbar configuration
            view: 'toolbar',
            id: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size
                },
            ],
        };
        const left = {
            // Left section layout
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme,
                    elements: [
                        {
                            width: 30,
                            css: 'back-button', // Back button configuration
                            view: 'button',
                            type: 'icon',
                            icon: 'wxi-angle-left',
                            id: 'back-button',
                            align: 'center',
                            click: () => {
                                // Click event for back button
                                $$('FilterPagoPremio').show(); // Show filter
                                $$('FilterPagoPremio').clear(); // Clear filter
                                $$('FilterPagoPremio').clearValidation(); // Clear validation
                                $$('formPagoPremio').hide(); // Hide form
                                $$('tablePagoPremio').hide(); // Hide table
                                $$('toolbar').hide(); // Hide toolbar
                                $$('pagerA').hide(); // Hide pager
                                $$('back-button').hide(); // Hide back button
                            },
                        },
                        { view: 'label', label: _('Pago Premio Virtuales') }, // Label for the view
                        {
                            type: 'wide',
                            css: 'close-bottom', // Close button configuration
                            cols: [
                                {
                                    view: 'icon',
                                    icon: 'wxi-close',
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Navigate to dashboard on click
                                },
                            ],
                        },
                    ],
                },
                FilterPagoPremio, // Adding filter component
                PagoPremio, // Adding PagoPremio component
                TablePagoPremio, // Adding table component
                toolbar, // Adding toolbar
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen
        return {
            // Return the main configuration object
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [left], // Left section
                },
            ],
        };
    }

    /**
     * Initializes the view.
     */
    init() {
        $$('back-button').hide(); // Hide back button on initialization
    }
}

// FILE DOCUMENTED
